import type { RouteRecordRaw } from 'vue-router'

const authorizationRoutes: RouteRecordRaw[] = [
  {
    path: 'authorization',
    name: 'authorization',
    meta: {
      titleKey: 'routes.authorization.title',
      icon: 'Lock',
      helpKey: 'authorization'
    },
    redirect: { name: 'tenant' },
    children: [
      {
        path: 'tenant',
        name: 'tenant',
        component: () => import('@/views/authorization/Tenant.vue'),
        meta: { titleKey: 'routes.authorization.tenant.title', helpKey: 'tenant' }
      },
      {
        path: 'admin-user',
        name: 'admin-user',
        component: () => import('@/views/authorization/AdminUser.vue'),
        meta: { titleKey: 'routes.authorization.admin-user.title', helpKey: 'admin_user' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/authorization/Role.vue'),
        meta: { titleKey: 'routes.authorization.role.title', helpKey: 'role' }
      },
      {
        // 🔴 `Q-060` 丙-1 前端（2026-10-21）：后台操作审计日志页（**只读**查询；
        // 后端 `GET /api/v1/audit/logs`，权限码 = 既有 `audit.read`）。
        // helpKey `audit_logs` 与后端帮助种子同名（`HELP_SEEDS` 已有 zh/en 两篇；
        // `tests/design-regression/test_helpkey_seed_coverage.py` 逐条校验 helpKey ⇒ 种子）。
        path: 'audit',
        name: 'audit',
        component: () => import('@/views/authorization/AuditLog.vue'),
        meta: { titleKey: 'routes.authorization.audit.title', helpKey: 'audit_logs' }
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/views/authorization/Personal.vue'),
        meta: { titleKey: 'routes.authorization.personal.title', helpKey: 'personal' }
      }
    ]
  }
]

export default authorizationRoutes
